export default __webpack_public_path__ + "static/media/hydro-unselected.965454a8.png";